<script lang="tsx" setup>
import type { JSX } from 'vue/jsx-runtime'

const props = defineProps<{
  value?: string | JSX.Element | null
}>()

function AsComponent() {
  const { value } = props

  if (typeof value === 'string')
    return <>{value}</>

  return value || null
}
</script>

<template>
  <AsComponent v-if="value" />
  <slot v-else />
</template>
